enum State {
  New = 'new',
  Added = 'added',
  Skipped = 'skipped',
}

export enum AcronymNameType {
  Jargon = 'Jargon',
  MissingWord = 'Missing Word',
  Number = 'Number',
}

export interface AcronymType {
  name?: string;
  state?: State;
  type?: AcronymNameType;
  pronounce?: string;
  clientId?: string;
  documentId?: string;
  addToDict?: boolean;
  skip?: boolean;
  followUp?: boolean;
  created?: string;
  resolved?: string;
}

export class AcronymTypeObject implements AcronymType {
  name?: string = '';
  state?: State = State.New;
  type?: AcronymNameType = undefined;
  pronounce?: string = '';
  clientId?: string = '';
  documentId?: string = '';
  addToDict?: boolean = false;
  skip?: boolean = false;
  followUp?: boolean = false;
  created?: string = '';
  resolved?: string = '';
}

export interface ApiResponseType {
  data?: AcronymType[] | AcronymType;
  errors?: Array<{
    message: string;
  }>;
}
